export default "__VITE_ASSET__DvPmms1X__"